// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  pageWrapper: {
    width: 1200,
    margin: '0 auto',
  },
  itemsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  headerSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerSectionLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  headerSectionRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  icons: {
    flexGrow: 0,
  },
  exportButton: {
    backgroundColor: '#E5EAEE',
    padding: '10px',
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridColumnGap: theme.spacing(1),
    alignItems: 'center',
  },
  exportButtonText: {
    color: '#021E40',
  },
  availableCredits: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  noOrderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '150px',
    gap: theme.spacing(2),
  },
});

export default styles;
